import { Link, useHistory } from "react-router-dom"
import { useEffect, useState } from "react";
import { Menu, Dropdown,Button } from 'antd';
import conf from '../conf/config'
import { useAuth } from 'oidc-react';
import { request, requestkind } from "../unit/request";
import { Modal } from "antd";
import { useLocation } from "react-router-dom";
import title from "../conf/title"
const menu = (auth: any) => {
    return (
        <Menu>
            <Menu.Item>
                <Link to="/profile">
                    个人资料
                </Link>
            </Menu.Item>
            <Menu.Item>
                <a target="_blank" rel="noopener noreferrer" href={conf.oidcConfig.authority + "/Account/ChangePWD"}>
                    密码修改
                </a>
            </Menu.Item>
            <Menu.Item>
                <Button type="link" style={{color:'rgba(0, 0, 0, 0.85)'}} onClick={() => {
                    auth.signOutRedirect()
                }}>注销</Button>
            </Menu.Item>
        </Menu>
    )
};

const Nav = () => {
    const auth = useAuth();
    const { pathname } = useLocation()
    console.log(pathname)
    const [name, setName] = useState<any>("")
    const [PartnerName, setPartnerName] = useState<any>("")
    const get = async () => {
        try {
            const json = await request({}, {}, requestkind.Authentication.GetUserInfo)
            console.log(json)
            const { IsSuccess, Msg, Data } = json
            if (IsSuccess) {
                const { UserDisplayName, PartnerName } = Data
                setName(UserDisplayName)
                setPartnerName(PartnerName)
            } else {
                // Modal.error({
                //     title: "发现错误",
                //     content: Msg
                // })
                console.log('error in nav (api : auth.get_userinfo)')
            }
        } catch (error) {
            console.log('error in nav',error)
            // Modal.error({
            //     title: '错误！',
            //     content: error.msg
            // });
        }
    }
    // useEffect(() => {
    //     if (auth && auth?.userData) {
    //         console.log('GET USER', auth?.userData)
    //         const { access_token } = auth?.userData
    //         const { name } = auth?.userData?.profile
    //         setName(name)
    //         console.log(access_token)
    //     }
    // }, [auth])
    useEffect(() => {
        if (pathname !== "/call-back") {
            get()
        }
    }, [pathname])
    if (pathname !== "/call-back") {
        return <header className="nav">
            <div className="box">
                <div
                    className="logo"
                    title="Partner Credit Management System"
                >
                    <Link to="/">
                        <img src="/images/logo.png" height="70px" alt="" />
                    </Link>
                    <Link to="/creditApply" className={pathname.replace("/", "").includes("creditApply") ? "active" : ""}>信用申请</Link>
                    <Link to="/guaranteeAdd" className={pathname.replace("/", "").includes("guaranteeAdd") ? "active" : ""}>担保申请</Link>
                    <Link to="/guaranteeWithdraw" className={pathname.replace("/", "").includes("guaranteeWithdraw") ? "active" : ""}>担保提取</Link>
                    <Link to="/download" className={pathname.replace("/", "").includes("download") ? "active" : ""}>{title.download}</Link>
                </div>
                <div className="profile">
                    <div className="ant-dropdown-link" style={
                        {
                            marginRight: '10px',
                            cursor: 'pointer'
                        }
                    } onClick={e => e.preventDefault()}>
                        <div className="com">{PartnerName}</div>
                        <div className="prfile">{name}</div>
                    </div>
                    <Dropdown overlay={menu(auth)}>
                        <div className="avatar"></div>
                    </Dropdown>
                </div>
            </div>
        </header>
    } else {
        return <></>
    }

}
export default Nav